import _elem from '../modules/_elem';
import {$} from '../util';


class SliderItem {
  constructor($content, __slider, _i) {
    this.__Slider = __slider;
    this.initialized = false;
    this.preloaded = false;
    this.$slide = _elem("div", "slide")
      .append($content)
      .appendTo(this.__Slider._$inner_wrp)
    ;
    if (this.__Slider.dotsEnabled) {
      this.$dot = _elem("span", "dot md-icnpre-page-dot").attr({
        role: "button",
        tabindex: 0,
        "aria-label": "kép " + (_i + 1)
      })
        .appendTo(this.__Slider._$dots)
        .on(this._evt.dot, this)
      ;
    }

    this.active = false;
  }

  init(itsfirstInstance) {
    if (this.initialized) {
      return this;
    }
    this.initialized = true;

    var slides = this.__Slider.slides;
    var tIndex = slides.indexOf(this);

    this.preload();

    if (!itsfirstInstance) {
      void (slides[tIndex + 1] && slides[tIndex + 1].preload());
      void (slides[tIndex - 1] && slides[tIndex - 1].preload());
    }

    return this;
  };

  preload() {
    const that = this;
    if (this.preloaded || this.garbage) {
      return this;
    }
    this.preloaded = true;
    this.$slide.addClass("preload")
      .find("img[data-src]")
      .each(this.fns.preloadImageEach)
      .css("opacity", 0.1)
      .load(function() {
        if (that.garbage) { return; }
        $(this).css("opacity", 1);
        that.$slide.removeClass("preload");
      });
    return this;
  };

  setActive(animate) {
    if (this.active) {
      return this;
    }

    this.init();

    this.$slide.addClass("active");
    if (this.$dot) {
      this.$dot
        .removeClass("md-icnpre-page-dot")
        .addClass("md-icnpre-page-dot-active")
      ;
    }
    this.active = true;
    this.resize();

    return this;
  };

  unsetActive() {
    if (!this.active) {
      return this;
    }

    this.$slide.removeClass("active");
    if (this.$dot) {
      this.$dot
        .removeClass("md-icnpre-page-dot-active")
        .addClass("md-icnpre-page-dot")
      ;
    }
    this.active = false;
    return this;
  };

  show() {
    this.__Slider.step(this);
  };

  resize() {
    // var t = this;
  };

  destroy() {
    if (this.$dot) {
      this.$dot.off(this._evt.dot).remove();
    }
    this.$slide.remove();
    for (const p in this) {
      if (this.hasOwnProperty(p)) { delete this[p]; }
    }
    this.garbage = true;
    // console.log('SLIDE ITEM GARBAGE', this);
  }
}

SliderItem.prototype.fns = {
  preloadImageEach: function() {
    this.setAttribute("src", this.getAttribute("data-src"));
  }
};


SliderItem.prototype._evt = {
  dot: {
    click: function(e) {
      e.data.show();
    },
    keydown: function(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        e.data.show();
      }
    }
  }
};

export default SliderItem;
